<template>
  <div>
    <div class="sheet-body">
      <div class="success-wrap">
        <div class="success-ring success-ring--green">
          <v-icon>mdi-lightning-bolt</v-icon>
        </div>
        <h2>All Done</h2>
        <p>Session complete and paid</p>
        <div class="success-detail">
          <div class="sd-row">
            <span class="k">Customer</span><span class="v">{{ name }}</span>
          </div>
          <div class="sd-row">
            <span class="k">Energy</span><span class="v">{{ payMethod?.energy_consumed || 0 }} kWh</span>
          </div>
          <div class="sd-row">
            <span class="k">Paid</span>
            <span class="v">Rs {{ payMethod.total_cost || 0 }} </span>
          </div>
          <div class="sd-row">
            <span class="k">Payment Type</span>
            <span class="v">{{ payMethod?.payment_type || "-" }}</span>
          </div>
          <!-- <div class="sd-row">
            <span class="k">Receipt</span><span class="v receipt-sent">Sent to customer ✓</span>
          </div> -->
        </div>
      </div>
    </div>
    <div>
      <button
        class="big-btn btn-primary"
        @click="$emit('click', 'close')"
      >
        Back to Bookings
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "BookingComplete",
  props: {
    item: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      name: this.item.customer_name,
      payMethod: "",
    };
  },
  mounted() {
    const params = {
      id: this.item?.booking_id || this.item?.charge_session?.session_id,
      booking_id: this.item?.booking_id,
      session_id: this.item?.charge_session?.session_id,
    };
    this.$store
      .dispatch("bookingOperator/getPriceSummary", params)
      .then((res) => {
        this.payMethod = res.body;
      });
  },
};
</script>
